import { API_ORIGIN } from '../config'
const API_BASE = `${API_ORIGIN}/api`

// Descarga el Excel con los datos del parque. Devuelve el nombre del archivo guardado.
export async function downloadParkExport(parkId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/export`)
  if (!response.ok) {
    const err = await response.json().catch(() => ({}))
    if (response.status === 403) throw new Error('Solo el administrador puede exportar los datos del parque')
    throw new Error(err.error || 'No se pudo generar el archivo')
  }
  const blob = await response.blob()
  const disposition = response.headers.get('Content-Disposition') || ''
  const match = /filename="?([^";]+)"?/i.exec(disposition)
  const filename = match ? match[1] : 'parkos-datos.xlsx'

  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.remove()
  setTimeout(() => URL.revokeObjectURL(url), 10000)
  return filename
}